import React from "react";

export default function ErrorModal({ open, onClose, errors }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <svg
              className="h-6 w-6 text-red-500 mr-2"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fillRule="evenodd"
                d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
                clipRule="evenodd"
              />
            </svg>

            <h3 className="text-lg font-medium text-gray-900">
              Erreurs de validation
            </h3>
          </div>

          <p className="text-sm text-gray-500 mb-4">
            Veuillez corriger les erreurs suivantes :
          </p>

          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
            {Object.entries(errors).map(([field, messages]) => (
              <li key={field}>
                <span className="font-medium">{field}:</span>{" "}
                {Array.isArray(messages) ? messages.join(", ") : messages}
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
            onClick={onClose}
          >
            J'ai compris
          </button>
        </div>
      </div>
    </div>
  );
}
